import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { getUserUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ManualEnrollmentAnalysisDetails = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  const enrolledByUserId = diagnosisReason.userId;
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: enrolledByUserId ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.MANUAL_ENROLL.withUser_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.MANUAL_ENROLL.withoutUser_jsx',
      elements: {
        ViewLink: UILink,
        ObjectNameLabel,
        UserNameLabel,
        b: 'b'
      },
      options: {
        objectNameLabel: {
          portalId: selectedEnrollment.portalId,
          objectTypeId: selectedEnrollment.objectTypeId,
          objectId: selectedEnrollment.objectId,
          showId: getIsInternal()
        },
        userId: enrolledByUserId,
        viewLink: {
          external: true,
          href: enrolledByUserId ? getUserUrl({
            portalId: selectedEnrollment.portalId,
            userId: enrolledByUserId
          }) : undefined
        }
      }
    })
  });
};
export default ManualEnrollmentAnalysisDetails;